export default __webpack_public_path__ + "static/media/top3.48a68bf3.png";